/* eslint import/prefer-default-export: 0 */

import remote from './remote';

export function sendEnquiry(data = {}) {
  return remote.post('contact', data);
}
